import { render, staticRenderFns } from "./UnAuthorized.vue?vue&type=template&id=7c92b01e&scoped=true&"
import script from "./UnAuthorized.vue?vue&type=script&setup=true&lang=js&"
export * from "./UnAuthorized.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UnAuthorized.vue?vue&type=style&index=0&id=7c92b01e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92b01e",
  null
  
)

export default component.exports